import React from 'react';

const Pagebreak = () => (
  <p
    style={{
      pageBreakBefore: 'always',
    }}
  />
);

export default Pagebreak;



// WEBPACK FOOTER //
// ./src/components/Pagebreak/index.js